import React from "react";
import { useState, useRef, useEffect } from "react";
import EmrConfigService from "../../../../services/EmrConfigService";
import EmrVisitsService from "../../../../services/EmrVisitsService";
import SearchHistory from "./SearchHistory";
import FieldsDisplay from "./FieldsDisplay";
import EMRFormRender from "./EmrFormRender";

const EmrPageTab = (props) => {
  const {
    selectedSubTab,
    visit_id,
    setExpandedSection,
    fetchProgressNotesByScreen,
    Loader,
    Toast,
    employeeId,
    expandedSection,
    selectedTab,
  } = props;

  // === State ===
  const [fields, setFields] = useState([]);
  const [selectedFormIds, setSelectedFormIds] = useState([]);
  const [formResponses, setFormResponses] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [overallSearch, SetOverallSearch] = useState("");
  const [checkedHistoryId, setCheckedHistoryId] = useState(null);
  const [recommendedActivities, setRecommendedActivities] = useState([]);
  const [progressApiTrigger, setProgressApiTrigger] = useState(0);
  const [fieldSearched, SetFieldSearched] = useState(false);
  const [highlightTerm, setHighlightTerm] = useState(null);
  const [isSearchFromDropdown, setIsSearchFromDropdown] = useState(false);
  const [activeSearchSource, setActiveSearchSource] = useState(null);
  const [currentSearchLabel, setCurrentSearchLabel] = useState("");
  const [normalCheckedFormIds, setNormalCheckedFormIds] = useState([]);

  // === Refs ===
  const searchTimeoutRef = useRef(null);
  const historyRef = useRef(null);
  const formCache = useRef({});

  // === Effects ===
  useEffect(() => {
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    searchTimeoutRef.current = setTimeout(() => {
      if (searchTerm.trim() === "") fetchEmrList();
      else handleSearch();
    }, 500);
    return () => clearTimeout(searchTimeoutRef.current);
  }, [searchTerm]);

  useEffect(() => {
    fetchEmrList();
    setSearchTerm("");
    fetchRecommendedActivities();
  }, [selectedSubTab]);

  useEffect(() => {
    fetchProgressNotesByScreen();
  }, [visit_id, progressApiTrigger, selectedSubTab]);

   useEffect(() => {
        fetchEmrList();            
  },[props.selectedBodyPart]);

  const fetchFormDataById = async (apikey, id) => {
    // if (formCache.current[id]) return formCache.current[id];
    try {
      const response = await EmrConfigService.getEmrFormById(apikey, id);
      formCache.current[id] = response?.data;
      return response?.data;
    } catch (error) {
      console.error(`Failed to fetch form for ID: ${id}`, error);
      return null;
    }
  };

  const fetchRecommendedActivities = async () => {
    try {
      const response = await EmrVisitsService.searchHistory(
        null,
        selectedSubTab
      );
      const results = response.data.list || [];
      const activities = results.map((item, index) => ({
        id: item.search_reference_id || `check-${index}`,
        label: item.search_value || "Unnamed",
      }));
      setRecommendedActivities(activities);
    } catch (error) {
      console.error("Failed to fetch recommended activities:", error);
      setRecommendedActivities([]);
    }
  };

  const fetchMatchFiels = async (term, callback = () => {}) => {
    try {
      SetOverallSearch(term);
      if (!term) return callback([]);
      const response = await EmrVisitsService.searchActivities(
        null,
        selectedSubTab,
        { common_search: term }
      );
      const options = response.data.list.map((item) => ({
        label: item.name || item.value || item.label,
        value: item.id || item.emr_form_id,
      }));
      callback(options);
    } catch (error) {
      console.error("Failed to fetch activities:", error);
      callback([]);
    }
  };

  const handleSearch = async (id, value, shouldSetFields = true) => {
    try {
      const payload = {
        field_search: searchTerm || "",
        common_search: "",
        history_value_search: "",
        id,
        value,
      };
      const results = await EmrVisitsService.fetchFieldsBySearch(
        null,
        selectedSubTab,
        payload
      );
      fetchRecommendedActivities();
      if (shouldSetFields) {
        const fieldsData = (results.data?.data || []).map((item) => ({
          emr_form_id: item.emr_form_id,
          name: item.name,
        }));
        SetFieldSearched(true);
        setFields(fieldsData);
      }
    } catch (err) {
      console.error("Search failed:", err);
    }
  };

  const fetchEmrList = async () => {
    try {
      const response = await EmrVisitsService.getEmrChartByScreen(
        selectedSubTab,
        visit_id,
        { is_active: 1,
          selected_BodyParts: props.selectedBodyPart || ""
         }
      );
      let fieldsData = [];
      let selectedIds = [];
      let normalIds = [];
      response.data.forEach((itm) => {
        fieldsData.push({ emr_form_id: itm.emr_form_id, name: itm.name });
        if (itm.is_chart) selectedIds.push(itm.emr_form_id);
        if (itm.is_normal) normalIds.push(itm.emr_form_id);
        if (itm.is_chart) handleCheckboxChange(itm.emr_form_id, true);
      });
      setSelectedFormIds(selectedIds);
      setNormalCheckedFormIds(normalIds);
      setFields(fieldsData);
      return fieldsData;
    } catch (e) {
      console.error("Fetch EMR Error:", e);
      return [];
    }
  };

  const handleCheckboxChange = async (
    emr_form_id,
    checked,
    replace = false
  ) => {
    setSelectedFormIds((prev) =>
      checked
        ? Array.from(new Set([...prev, emr_form_id]))
        : prev.filter((id) => id !== emr_form_id)
    );

    if (checked) {
      try {
        const form = await fetchFormDataById(selectedSubTab, emr_form_id);
        const filledDataRes = await EmrVisitsService.fetchFilledFieldData(
          null,
          visit_id,
          emr_form_id
        );
        const filledFields = filledDataRes?.data?.data?.emr_field || [];
        const filledFieldMap = {};
        filledFields.forEach((field) => {
          field.id.forEach((id) => {
            filledFieldMap[id] = field.value;
          });
        });
        const prefilledForm = {
          ...form,
          fields: form.fields.map((field) => ({
            ...field,
            prefillValue: filledFieldMap[field.id] || "",
          })),
        };
        setFormResponses((prev) => {
          if (replace) return { ...prev, [selectedSubTab]: [prefilledForm] };
          const prevList = prev[selectedSubTab] || [];
          if (
            prevList.some(
              (formItem) => formItem.emr_form_id === prefilledForm.emr_form_id
            )
          )
            return prev;
          return { ...prev, [selectedSubTab]: [...prevList, prefilledForm] };
        });
      } catch (error) {
        console.error("Error fetching prefilled field data:", error);
      }
    } else {
      handleNormalSubmit(emr_form_id, 0, 1);
      setFormResponses((prev) => {
        const updated = (prev[selectedSubTab] || []).filter(
          (form) => form?.emr_form_id !== emr_form_id
        );
        return { ...prev, [selectedSubTab]: updated };
      });
    }
  };

  const handleNormalSubmit = async (form_id, isNormal = 0, is_clear = 0, clearAll = 0) => {
    try {
      const payload = {
        employee_id: employeeId,
        screen_type: selectedSubTab,
        emr_field: "",
        is_normal: isNormal,
        chart_update: 0,
        is_clear: is_clear,
        clear_all: clearAll, // Add clear_all parameter
      };
      Loader(true);
      const result = await EmrVisitsService.saveFields(
        null,
        visit_id,
        form_id,
        payload
      );
      Loader(false);
      if (result?.status === 200 || result?.status === "SUCCESS") {
        if (isNormal === 1) {
          Toast.success("Marked as normal successfully.");
          fetchProgressNotesByScreen();
        }
      } else {
        Toast.error("Failed to mark as normal.");
      }
    } catch (err) {
      Loader(false);
      console.error("Normal save failed:", err);
      Toast.error("Something went wrong.");
    }
  };

  const handleFormUpdate = async (form_id) => {
    try {
      const form = await fetchFormDataById(selectedSubTab, form_id);
      const filledDataRes = await EmrVisitsService.fetchFilledFieldData(
        null,
        visit_id,
        form_id
      );
      const filledFields = filledDataRes?.data?.data?.emr_field || [];
      const filledFieldMap = {};
      filledFields.forEach((field) => {
        field.id.forEach((id) => {
          filledFieldMap[id] = field.value;
        });
      });
      const updatedForm = {
        ...form,
        fields: form.fields.map((field) => ({
          ...field,
          prefillValue: filledFieldMap[field.id] || "",
        })),
      };
      setFormResponses((prev) => {
        const prevList = prev[selectedSubTab] || [];
        const updatedList = prevList.map((f) =>
          f.emr_form_id === form_id ? updatedForm : f
        );
        return { ...prev, [selectedSubTab]: updatedList };
      });
    } catch (err) {
      console.error("Failed to refresh filled form:", err);
    }
  };

  const handleHistoryClick = async (selectedId) => {
    const matchedForm = fields.find(
      (f) => String(f.emr_form_id) === String(selectedId)
    );
    if (matchedForm) {
      await handleCheckboxChange(matchedForm.emr_form_id, true, true);
      setFields([
        { emr_form_id: matchedForm.emr_form_id, name: matchedForm.name },
      ]);
      setExpandedSection(matchedForm.emr_form_id);
      setHighlightTerm(matchedForm.name);
      handleSearch(matchedForm.emr_form_id, matchedForm.name, false);
      setCurrentSearchLabel(matchedForm.name);
      return;
    }

    const allFormIds = fields.map((f) => f.emr_form_id);
    const formDetailsList = await Promise.all(
      allFormIds.map((id) => fetchFormDataById(selectedSubTab, id))
    );

    for (let i = 0; i < formDetailsList.length; i++) {
      const form = formDetailsList[i];
      const originalField = fields[i];

      for (const field of form.fields) {
        if (String(field.id) === String(selectedId)) {
          await handleCheckboxChange(originalField.emr_form_id, true, true);
          setFields([
            {
              emr_form_id: originalField.emr_form_id,
              name: originalField.name,
            },
          ]);
          setExpandedSection(originalField.emr_form_id);
          setHighlightTerm(field.label);
          setCurrentSearchLabel(field.label);
          handleSearch(field.id, field.label, false);
          return;
        }

        const matchedOption = (field.options || []).find(
          (opt) => String(opt.id) === String(selectedId)
        );
        if (matchedOption) {
          await handleCheckboxChange(originalField.emr_form_id, true, true);
          setFields([
            {
              emr_form_id: originalField.emr_form_id,
              name: originalField.name,
            },
          ]);
          setExpandedSection(originalField.emr_form_id);
          setHighlightTerm(matchedOption.value || field.label);
          setCurrentSearchLabel(matchedOption.value);
          handleSearch(
            matchedOption.id,
            matchedOption.value || field.label,
            false
          );
          return;
        }
      }
    }

    setFields([]);
    setFormResponses((prev) => ({ ...prev, [selectedSubTab]: [] }));
    setSelectedFormIds([]);
    setExpandedSection(null);
    setHighlightTerm(null);
    setCurrentSearchLabel("No Match Found");
  };

  const checkHandle = (val, _eventWrapper, id, label) => {
    if (val) {
      setCheckedHistoryId(id);
      setActiveSearchSource("history");
      setCurrentSearchLabel(label);
      handleHistoryClick(id);
    } else {
      setCheckedHistoryId(null);
      setHighlightTerm(null);
      setSearchTerm("");
      setActiveSearchSource(null);
      setCurrentSearchLabel("");
      handleSearch();
      fetchEmrList();
    }
  };

  const allSelected =
    fields.length > 0 &&
    fields.every((f) => selectedFormIds.includes(f.emr_form_id));

  return (
    <div className="sh_cardBody" style={{ height: "calc(40vh - 120px)" }}>
      <div className="row">
        
        {/* <SearchHistory
          checkedHistoryId={checkedHistoryId}
          activeSearchSource={activeSearchSource}
          overallSearch={overallSearch}
          fetchMatchFiels={fetchMatchFiels}
          setActiveSearchSource={setActiveSearchSource}
          setIsSearchFromDropdown={setIsSearchFromDropdown}
          SetOverallSearch={SetOverallSearch}
          handleHistoryClick={handleHistoryClick}
          currentSearchLabel={currentSearchLabel}
          setCheckedHistoryId={setCheckedHistoryId}
          setSearchTerm={setSearchTerm}
          setHighlightTerm={setHighlightTerm}
          setCurrentSearchLabel={setCurrentSearchLabel}
          fetchEmrList={fetchEmrList}
          handleSearch={handleSearch}
          historyRef={historyRef}
          recommendedActivities={recommendedActivities}
          isSearchFromDropdown={isSearchFromDropdown}
          checkHandle={checkHandle}
        /> */}

        {/* second column */}
        <FieldsDisplay
          fields={fields}
          normalCheckedFormIds={normalCheckedFormIds}
          handleNormalSubmit={handleNormalSubmit}
          setNormalCheckedFormIds={setNormalCheckedFormIds}
          setSelectedFormIds={setSelectedFormIds}
          selectedFormIds={selectedFormIds}
          handleCheckboxChange={handleCheckboxChange}
          fieldSearched={fieldSearched}
          handleSearch={handleSearch}
          SetFieldSearched={SetFieldSearched}
          allSelected={allSelected}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          setActiveSearchSource={setActiveSearchSource}
          setCurrentSearchLabel={setCurrentSearchLabel}
          activeSearchSource={activeSearchSource}
          selectedTab={selectedTab}
        />

        {/* third column */}
        <EMRFormRender
          setProgressApiTrigger={setProgressApiTrigger}
          fetchProgressNotesByScreen={fetchProgressNotesByScreen}
          fields={(formResponses[selectedSubTab] || []).filter((form) =>
            selectedFormIds.includes(form.emr_form_id)
          )}
          visit_id={visit_id}
          employeeId={employeeId}
          Toast={Toast}
          highlightTerm={highlightTerm}
          expandedSection={expandedSection}
          setExpandedSection={setExpandedSection}
          selectedSubTab={selectedSubTab}
          onFormUpdate={handleFormUpdate}
          selectedTab={selectedTab}
        />
      </div>
    </div>
  );
};

export default EmrPageTab;
